import CoachHubUserModel from 'models/coachhub_user';


export default CoachHubUserModel.extend({
  idAttribute: 'url',
  url: function () {
    return this.get('url');
  }
});



// WEBPACK FOOTER //
// ./static/js/models/coach.js